import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "flex gap-2" }
const _hoisted_3 = { class: "w-60" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_create_form = _resolveComponent("create-form")!
  const _component_edit_form = _resolveComponent("edit-form")!
  const _component_delete_modal = _resolveComponent("delete-modal")!
  const _component_confirmation_modal = _resolveComponent("confirmation-modal")!
  const _component_loader = _resolveComponent("loader")!
  const _component_table_action_header = _resolveComponent("table-action-header")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_custom_table = _resolveComponent("custom-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_main_section = _resolveComponent("main-section")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isCreateFormModalOpened)
      ? (_openBlock(), _createBlock(_component_create_form, {
          key: 0,
          "is-create-form-modal-opened": _ctx.isCreateFormModalOpened,
          "refresh-data": _ctx.refreshData,
          onToggleModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCreateFormModalOpened = false))
        }, null, 8, ["is-create-form-modal-opened", "refresh-data"]))
      : _createCommentVNode("", true),
    (_ctx.isEditModalOpened)
      ? (_openBlock(), _createBlock(_component_edit_form, {
          key: 1,
          "is-edit-modal-opened": _ctx.isEditModalOpened,
          "refresh-data": _ctx.getResources,
          "selected-resource": _ctx.selectedResource,
          onToggleModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isEditModalOpened = false))
        }, null, 8, ["is-edit-modal-opened", "refresh-data", "selected-resource"]))
      : _createCommentVNode("", true),
    (_ctx.isDeleteModalOpened)
      ? (_openBlock(), _createBlock(_component_delete_modal, {
          key: 2,
          "is-deleting": _ctx.isDeleteModalOpened,
          onCancelDelete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDeleteModalOpened = false)),
          onToggleModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDeleteModalOpened = false)),
          onConfirmDelete: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openConfirmationModal('delete')))
        }, null, 8, ["is-deleting"]))
      : _createCommentVNode("", true),
    _createVNode(_component_confirmation_modal, {
      "delete-text": _ctx.confirmationModalText,
      "is-confirmation-modal-opened": _ctx.isConfirmationModalOpened,
      onConfirmAction: _ctx.confirmationModalAction,
      onCloseConfirmationModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isConfirmationModalOpened = false)),
      onToggleModal: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isConfirmationModalOpened = false))
    }, null, 8, ["delete-text", "is-confirmation-modal-opened", "onConfirmAction"]),
    _createVNode(_component_main_section, null, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_table_action_header, {
                icon: ['fas', 'add'],
                "permission-id": _ctx.permissions.GlobalAuthView,
                title: _ctx.$t('GlobalAuthorization.Title'),
                description: " ",
                "button-text": "Create",
                onExecuteMethod: _ctx.toggleCreateModal
              }, null, 8, ["permission-id", "title", "onExecuteMethod"]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_select, {
                  class: "mt-1 w-60",
                  modelValue: _ctx.selectedFilterOption,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedFilterOption) = $event)),
                  options: _ctx.filterOptions,
                  reduce: (option) => option.key,
                  label: "label",
                  clearable: false
                }, null, 8, ["modelValue", "options", "reduce"]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_input_field, {
                    modelValue: _ctx.searchEmailText,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchEmailText) = $event)),
                    placeholder: "Search by email",
                    "no-padding": true,
                    onInput: _ctx.handleEmailSearch
                  }, null, 8, ["modelValue", "onInput"])
                ])
              ]),
              _createVNode(_component_custom_table, {
                "is-data-source-loading": _ctx.isDataSourceLoading,
                options: _ctx.options,
                "table-data": _ctx.resources.items,
                "table-headers": _ctx.tableHeaders,
                onForceRefresh: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getResources())),
                onSelectedRows: _ctx.getSelectedRows
              }, null, 8, ["is-data-source-loading", "options", "table-data", "table-headers", "onSelectedRows"]),
              _createVNode(_component_pagination, {
                "pagination-data": _ctx.resources,
                onPageChange: _ctx.handlePageChange,
                onPageSizeChange: _ctx.handlePageSizeChange
              }, null, 8, ["pagination-data", "onPageChange", "onPageSizeChange"])
            ]))
      ]),
      _: 1
    })
  ], 64))
}